import React from 'react';
import { PropTypes } from 'utils/wrappers';
import Price from 'components/Common/Property/Price';
import classes from 'components/Page/Property/styles/PaymentCalculator.module.scss';
import { Button } from 'reactstrap';
import { showCheckoutModal, updateCheckoutModalTypeAction } from 'redux/actions/modalsActions';
import { connect } from 'react-redux';

const PayInFull = ({ property, className, updateCheckoutModalType }) => {
    const total = property.finances.price;
    const discountPercentage = 0.05;
    const discount = Math.round(total * discountPercentage);
    const processingFee = property.finances.processingFee;

    const openCheckoutModal = () => {
        updateCheckoutModalType('full');

        showCheckoutModal();
    };

    return (
        <div className='payment-calculator-pay-in-full'>
            <h4 className={'font-weight-bold'}>Pay in Full</h4>
            <div className={'row mb-2'}>
                <div className={'col-6'}>Purchase Price</div>
                <div className={'col-6 text-right'}>
                    <Price value={total} />
                </div>
            </div>
            <div className={'row mb-2'}>
                <div className={'col-6'}>Discount ({discountPercentage * 100}%)</div>
                <div className={'col-6 text-right'}>
                    - <Price value={discount} />
                </div>
            </div>
            <div className={'row mb-2'}>
                <div className={'col-6'}>Processing Fee</div>
                <div className={'col-6 text-right'}>
                    + <Price value={processingFee} />
                </div>
            </div>
            <div className={'row mb-2 font-weight-bold'}>
                <div className={'col-6'}>Total due Today</div>
                <div className={'col-6 text-right'}>
                    <Price value={total - discount + processingFee} />
                </div>
            </div>
            <div className={classes['buy-button']}>
                <Button color='primary' size='lg' className={classes.button} onClick={openCheckoutModal}>
                    Buy it now
                </Button>
            </div>
        </div>
    );
};

PayInFull.propTypes = {
    property: PropTypes.shape({
        listingId: PropTypes.string.isRequired,
        finances: PropTypes.shape({
            price: PropTypes.number.isRequired,
            processingFee: PropTypes.number.isRequired,
        }).isRequired,
    }).isRequired,
    className: PropTypes.string,
};

const mapDispatchToProps = {
    updateCheckoutModalType: updateCheckoutModalTypeAction,
};

export default connect(null, mapDispatchToProps)(PayInFull);
